import { get } from "lodash";
import getDebtor from "./getDebtor";

const getDebtorCompanyName = state =>
  get(getDebtor(state), "dba") || get(getDebtor(state), "company_name", "");

export default getDebtorCompanyName;
